import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IDocumentBlob } from '../../types';

export interface IDownloadStoreDocumentBlobParams {
  documentId: number;
}

export interface IDownloadStoreDocumentBlobResponse {
  document: IDocumentBlob;
}

export const downloadStoreDocumentAdminBlob = (params: IDownloadStoreDocumentBlobParams) :
AxiosPromise<IDownloadStoreDocumentBlobResponse> => {
  return Fetch().then(axios => axios.get(`store-documents/admin/blob?documentId=${params.documentId}`));
};
